"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const LabelLocation_1 = require("./LabelLocation");
const LabeledInputFieldWidget_1 = tslib_1.__importDefault(require("../widget/LabeledInputFieldWidget"));
const fmko_ts_common_1 = require("fmko-ts-common");
class WCAGRadioButton extends LabeledInputFieldWidget_1.default {
    constructor(args) {
        super({
            ...args,
            inputType: "radio"
        });
        const { checkedInitially = false, checkedValue } = args;
        this.checkedValue = checkedValue;
        this.setChecked(checkedInitially);
    }
    getValue() {
        return this.isChecked() ? this.checkedValue : undefined;
    }
    setValue(value, fireEvents = false) {
        const val = value !== undefined && value !== null && value !== false
            ? this.checkedValue
            : undefined;
        this.setChecked(!!val);
        if (fireEvents) {
            fmko_ts_common_1.ValueChangeEvent.fire(this, val);
        }
    }
    getCheckedValue() {
        return this.checkedValue;
    }
    getName() {
        return this.fieldElement.name || "";
    }
    setName(name) {
        this.fieldElement.name = name;
    }
    clearValue(fireEvents = false) {
        this.fieldElement.checked = false;
        super.clearValue(fireEvents);
    }
    isChecked() {
        return this.fieldElement.checked;
    }
    setChecked(value) {
        this.fieldElement.checked = value;
    }
    parseFieldElementValue() {
        return this.fieldElement.checked ? this.checkedValue : undefined;
    }
    setFieldElementValue(value) {
        this.getFieldElement().checked = value !== undefined;
    }
    decorateLabeledInputFieldWidgetElement(args) {
        const { labelLocation = LabelLocation_1.LabelLocation.RIGHT } = args;
        this.element = document.createElement("div");
        this.element.classList.add("radio-field");
        this.element.classList.add("flex-row");
        if (labelLocation === LabelLocation_1.LabelLocation.RIGHT) {
            this.add(this.fieldElement);
            this.add(this.labelElement);
        }
        else {
            this.add(this.labelElement);
            this.add(this.fieldElement);
        }
    }
}
exports.default = WCAGRadioButton;
//# sourceMappingURL=WCAGRadioButton.js.map